(() => {
  function scrollToNextSiblingIfViewportInsideFeature() {
    const features = document.querySelectorAll('.feature-focus');
    if (!features.length) return;

    const centerY = window.innerHeight / 2;

    for (const feature of features) {
      const rect = feature.getBoundingClientRect();
      if (rect.top <= centerY && rect.bottom >= centerY) {
        const parentSection = feature.parentElement;
        if (!parentSection) return;
        const next = parentSection.nextElementSibling;
        if (next) {
          requestAnimationFrame(() => {
            next.scrollIntoView({ behavior: 'smooth', block: 'start' });
          });
        }
        break;
      }
    }
  }

  window.addEventListener('load', () => {
    scrollToNextSiblingIfViewportInsideFeature()
  });

  let videos = document.querySelectorAll(
    ".feature-focus__video-bg--1, .feature-focus__video-bg--1-mobile, .feature-focus__video-bg--3, .feature-focus__video-bg--3-mobile"
  );
  if (!videos.length) return;

  function initScrollScrub(video) {
    let duration = video.duration;

    if (window.ScrollTrigger) {
      gsap.delayedCall(2, () => {
        window.ScrollTrigger.create({
          trigger: video,
          start: 'top center',
          end: 'bottom top',
          scrub: true,
          onUpdate: self => {
            let time = duration * self.progress;
            video.currentTime = time;
          }
        });
      })
    }
    else {
      console.warn("ScrollTrigger is not available.");
    }
  }

  function waitForVideoReady(video) {
    return new Promise((resolve) => {
      if (video.readyState >= 3) {
        resolve();
      } else {
        video.addEventListener('canplay', resolve, { once: true });
      }
    });
  }

  videos.forEach(async (video) => {
    video.play();
    video.pause();
    video.currentTime = 0.01;

    await waitForVideoReady(video);
    initScrollScrub(video);
  });
})();
